import { Routes } from '@angular/router';

const consultation = () =>
  import('./features/consultation/consultation.component').then(
    (m) => m.ConsultationComponent,
  );

export const routes: Routes = [
  /**
   * The shape the APK actually loads.
   *
   * It opens a server-supplied URL with no query parameters, so the room has to
   * travel in the path. This matches the deployed `patient/join/:roomName`
   * route, which means an existing consultation link keeps working against this
   * app without the backend changing.
   *
   * No guard: the patient's phone has no login, and a consultation link is
   * already the credential.
   */
  { path: 'patient/join/:roomName', loadComponent: consultation },

  /** The doctor's link. Same page, different role, resolved from `?role=`. */
  { path: 'consultation/:roomName', loadComponent: consultation },
  { path: 'consultation', loadComponent: consultation },

  // Development entry: no room in the path, so the page offers a field.
  { path: '', loadComponent: consultation },
  { path: '**', redirectTo: '' },
];
